export const classes = {
  dialogBody: 'pt-4 pb-12',
};
